const LibraryIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 17.104">
            <g id="Group_7899" data-name="Group 7899" transform="translate(0 0)">
                <g id="Group_7898" data-name="Group 7898" transform="translate(0 0)">
                    <path
                        id="Path_3370"
                        data-name="Path 3370"
                        d="M16.665,16.3A2.534,2.534,0,0,0,19.2,13.768V10.51a1.449,1.449,0,0,0-1.448-1.448H14.13M16.665,16.3a2.535,2.535,0,0,1-2.535-2.533V9.062M16.665,16.3H2.908A2.534,2.534,0,0,1,.375,13.768V1.823A1.448,1.448,0,0,1,1.823.375h10.86A1.447,1.447,0,0,1,14.13,1.823V9.062M3.271,10.51h7.964m-1.448-2.9H4.719a1.448,1.448,0,1,1,0-2.9H9.787a1.448,1.448,0,1,1,0,2.9Z"
                        transform="translate(0.213 0.214)"
                        fill="none"
                        stroke="var(--icon-color)"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth="0.75"
                    />
                </g>
            </g>
        </svg>
    );
};

export default LibraryIcon;
